import styled from 'styled-components'
import { Text } from 'components/Text'

export const Divider = styled.div`
  height: 2px;
  background-color: rgba(0, 0, 0, 0.05);
`

export const MenuContainer = styled.div`
  padding: 0 15px;

  :last-child ${Divider} {
    display: none;
  }
`

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 17px 0;
  cursor: pointer;
`

export const Photo = styled.div`
  height: 50px;
  width: 50px;
  margin-left: 20px;

  background-color: ${props => props.theme.colors.lighterGrey};
  background-image: url(${props => props.image});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`

export const DetailsSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Description = styled.div`
  margin-top: 4px !important;
  font-size: 11px;
  color: #808080;
  line-height: 15px;
`

export const Price = styled(Text)`
  margin-top: 4px !important;
`
